import * as React from "react";
import { DrawerContainer, DrawerList, InputIcon, InputSuggestable, InputContainer, DrawerOptionsContainer, DrawerEmptyState, LoadMoreTarget } from './styles';
import { SearchableDropdownItem } from './constants';
import { FilterSuggestDrawerItem } from './SearchableDropdownItem';
import InnerLoader from '../InnerLoader';
import { KEYS } from 'common/constants';
import { SIZE } from 'common/sizes';
// import { FILTER_SUGGEST_DRAWER_TEXTS } from 'src/common/texts';
import { ReactComponent as ArrowIcon } from 'common/images/search_arrow.svg'
import { ReactComponent as ExIcon } from 'common/images/search_ex.svg'
import { ArrowDownIcon } from 'common/icons/arrowdownIcon';

export interface FilterSuggestDrawerProps {
    value: string
    options: SearchableDropdownItem[]
    emptyText: string
    isLoading: boolean
    containerDiv?: HTMLDivElement | null
    canLoadMore?: boolean
    shouldShowOptions?: boolean
    notSearchable?:boolean
    arrowSimple?: boolean
    inputStyle?: any
    labelStyle?: any

    onSelectAllSelected?: () => void
    onValueChange: (value: any) => void
    onOptionSelected: (SearchableDropdownItem) => void
    dismissDrawer: () => void
    onScrollNearBottom?: () => void
}

export interface FilterSuggestDrawerState {
    focusedIndex: number
}

export const FilterSuggestDrawer = (props: FilterSuggestDrawerProps) => {

    const inputElement = React.useRef<HTMLInputElement>() as any;
    const drawer = React.useRef<HTMLElement>() as any;
    const drawerList = React.useRef() as any;
    const listItemHeight = React.useRef() as any;
    const intObserv = React.useRef<IntersectionObserver>();
    const lastOne = React.useRef() as any;
    const [lastOneCache, setLastOneCache] = React.useState();

    const [focusedIndex, setFocusedIndex] = React.useState(-1);

    React.useEffect(() => {
        if (!(props.notSearchable??false))
            inputElement?.current?.focus();
    }, [inputElement.current]);

    React.useEffect(() => {
        if (!intObserv.current && drawerList.current) {
            let options = {
                root: drawerList.current,
                rootMargin: `${SIZE.ONE}px`,
                threshold: 1.0
            }
            intObserv.current = new IntersectionObserver(onIntersectionObserver, options);
        }
        if (intObserv.current && lastOne.current) {
            intObserv.current.observe(lastOne.current)

        }

    }, [intObserv.current, drawerList.current, lastOne.current, lastOneCache]);

    // componentDidUpdate() {
    //     const itemSize = SIZE.FOUR + 2;
    //     if (this.drawer && this.state.focusedIndex !== -1 && this.drawerList) {
    //         const currentScrollItem = itemSize * this.state.focusedIndex;
    //         const drawerListHeight = this.drawerList.clientHeight;
    //         if ((currentScrollItem + itemSize) > (this.drawer?.scrollTop + drawerListHeight)) {
    //             this.drawer.scrollTop = currentScrollItem;
    //         } else if (currentScrollItem < this.drawer?.{
    //             const timesInPage = Math.floor(drawerListHeight / itemSize) - 1;
    //             this.drawer.scrollTop = Math.max(currentScrollItem - timesInPage * itemSize, 0);
    //         }
    //     }
    // }

    return (
        <DrawerContainer onKeyDown={onKeyPress}>
            {
                renderInput()
            }
            {
                props.shouldShowOptions &&
                <DrawerOptionsContainer ref={drawer} >
                    {
                        renderContent()
                    }
                </DrawerOptionsContainer>
            }

        </DrawerContainer>
    );

    function renderInput() {
        const height = props.containerDiv ? `${props.containerDiv.clientHeight}px` : undefined;
        return (
            <InputContainer height={height} style={props.inputStyle}>
                <InputIcon className={"icon-search"} />
                <InputSuggestable
                    ref={inputElement}
                    value={props.value}
                    onChange={props.onValueChange}
                    readOnly={props.notSearchable}
                    
                />
                {
                    props.isLoading &&
                    <InputIcon>
                        <InnerLoader />
                    </InputIcon>
                }
                {
                    props.value && props.value.length > 0 &&
                    <InputIcon onClick={() => onClearFieldClick()}>
                        <ExIcon />
                    </InputIcon>
                }
                {
                    <InputIcon onClick={() => props.dismissDrawer()}>
                        {props.arrowSimple ? <ArrowDownIcon/>:<ArrowIcon />}
                    </InputIcon>
                }
            </InputContainer >
        )
    }

    function renderContent() {
        if (props.options && props.options.length > 0) {
            return (
                <DrawerList
                    ref={drawerList}
                    onScroll={(e: any)=> handleScroll(e)}
                >
                    {
                        props.options.map((opt, index) => {
                            return (
                                <div key={opt.id}>
                                    <FilterSuggestDrawerItem
                                        option={opt}
                                        searchTerm={props.value}
                                        onOptionSelected={props.onOptionSelected}
                                        focused={focusedIndex === index}
                                    />
                                    {
                                        index === props.options.length - 1 && props.canLoadMore &&
                                        <LoadMoreTarget
                                            key={`LAST${props.options[props.options.length - 1].id}`}
                                            className={`LAST${props.options[props.options.length - 1].id}`}
                                        >
                                            <InnerLoader />
                                        </LoadMoreTarget>
                                    }
                                </div>
                            )
                        })

                    }
                </DrawerList>
            );
        } else {
            return (
                <DrawerEmptyState>
                    {
                        props.emptyText
                    }
                </DrawerEmptyState>
            )
        }
    }


    function handleScroll (e: any) {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom && props.onScrollNearBottom) props.onScrollNearBottom();
    }

    function onKeyPress(event: { key: string }) {
        let currentIndex = focusedIndex;
        if (event && event.key) {
            switch (event.key) {
                case KEYS.ARROW_DOWN:
                    currentIndex = Math.min(props.options.length - 1, currentIndex + 1)
                    break;
                case KEYS.ARROW_UP:
                    currentIndex = Math.max(0, currentIndex - 1)
                    break;
                case KEYS.ENTER:
                    if (props.options && currentIndex !== -1 && props.options.length >= currentIndex) {
                        props.onOptionSelected(props.options[currentIndex]);
                        props.dismissDrawer();
                    }
                    break;
                case KEYS.ESCAPE:
                case KEYS.TAB:
                    props.dismissDrawer()
            }
        }
        setFocusedIndex(currentIndex)
    }

    function handleListItemNode(node) {
        if (node && node.clientHeight) {
            listItemHeight.current = node.clientHeight;
        }
    }

    function onIntersectionObserver(e: IntersectionObserverEntry[]) {
        if (e[0].isIntersecting) {
            if (props.onScrollNearBottom) {
                props.onScrollNearBottom()
            }
        }
    }

    function setLastTargetRef(node) {
        if (lastOne.current) {
            if (lastOne.current === node) {
                return;
            }
        }
        lastOne.current = node;
        setLastOneCache(lastOne.current)
    }

    function onClearFieldClick() {
        props.onValueChange({ target: { value: "" } });
    }

}
